export default __webpack_public_path__ + "static/media/eye-closed.3ca85674.svg";